const STORAGE_KEY = 'acceptedPrivacyPolicy';

/** Mirrors Android `UserLocalStore.acceptedPrivacyPolicy`. */
export function hasAcceptedPrivacyPolicy(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setAcceptedPrivacyPolicy(accepted: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, accepted ? 'true' : 'false');
  } catch {
    // ignore quota / private mode
  }
}
